import { render, staticRenderFns } from "./ComplaintSectorInfo.vue?vue&type=template&id=4dbf016b&"
import script from "./ComplaintSectorInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports